import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { ExampleListRequest, ExampleListResponse } from "./types";

export const exampleListService = (params: ExampleListRequest) =>
  RestAPIClient.call<ExampleListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });
